import request from '@/utils/request'

/**
 * 获取供应链列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listChainSupplier(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.listChainSupplier',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 添加供应链
 * @param {Object} data 供应链数据
 * @returns {Promise} Promise对象
 */
export function saveChainSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.saveChainSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新供应链
 * @param {Object} data 供应链数据
 * @returns {Promise} Promise对象
 */
export function updateChainSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.updateChainSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除供应链
 * @param {Object} data 供应链数据
 * @returns {Promise} Promise对象
 */
export function deleteChainSupplier(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/chainSupplier.deleteChainSupplier',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export default {
  listChainSupplier,
  saveChainSupplier,
  updateChainSupplier,
  deleteChainSupplier
}